import { MapsMarkerClusterer } from './google-map-cluster.service';

export default angular
  .module('sfMobile.services.google-map-cluster', [])
  .service('MarkerClustererService', MapsMarkerClusterer).name;
